export { default } from "./TableBody.mjs";
export { default as tableBodyClasses } from "./tableBodyClasses.mjs";
export * from "./tableBodyClasses.mjs";